// extracted by mini-css-extract-plugin
export default {"container":"te3zEQEj9avdxlrmb0Q-iw==","lottie":"E97EtQ5S9qR72LdLIMnD7w==","textContainer":"pkkGvHkPfBuvlLxinH-ajA=="};